(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ballr-football-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  const allowedKeys = ['utm_source','utm_medium','utm_campaign','utm_id','utm_content','utm_term','gclid','gbraid','wbraid'];
  document.querySelectorAll('[data-ballr-landing]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const query = new URLSearchParams(location.search);
    root.querySelectorAll('a[data-preserve-attribution]').forEach(link => {
      const url = new URL(link.href, location.href);
      if (url.hostname !== 'ballr.cc' && url.origin !== location.origin) return;
      for (const key of allowedKeys) {
        const value = query.get(key);
        if (value && value.length <= 2048 && !url.searchParams.has(key)) url.searchParams.set(key, value);
      }
      link.href = url.href;
    });
    root.querySelectorAll('.mobile-menu a').forEach(link => link.addEventListener('click', () => { link.closest('details').open = false; }));
    const cover = root.querySelector('[data-play-video]');
    const video = root.querySelector('video[data-video-src]');
    if (!cover || !video) return;
    cover.addEventListener('click', () => {
      if (!video.src) video.src = video.dataset.videoSrc;
      cover.hidden = true;
      video.hidden = false;
      video.controls = true;
      video.tabIndex = 0;
      video.focus();
      const result = video.play();
      if (result) result.catch(() => { video.controls = true; video.dispatchEvent(new CustomEvent('ballr:video_play_rejected')); });
    });
    video.addEventListener('error', () => {
      root.querySelector('[data-video-error]').hidden = false;
    });
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
